import React from "react";
import { Box } from "@material-ui/core";
import { handleNullValue } from "../util/tableUtils";
import { makeStyles } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";
import Link from "@mui/material/Link";

import { Typography } from "@mui/material";

// Note: compont=div is needed in order to avoid warning about <div> inside <p>.

export const DisplayField = (props) => (
  <Box m={0.5} mb="0.5em">
    <Typography variant="body2" component="div" display="block">
      <Box sx={{ fontWeight: 600 }}>{props.label}</Box>
    </Typography>

    <Typography variant="caption" gutterBottom>
      {handleNullValue(props.value || "")}
    </Typography>
  </Box>
);

export const DisplayIconField = ({ icon, value, tooltipMsg }) => {
  const useStyles = makeStyles(() => ({
    copyableLink: {
      userSelect: "text",
    },
    typographyWithHover: {
      marginLeft: "4px",
    },
  }));
  const classes = useStyles();
  if (!value && value !== 0) return "";

  return (
    <Box display="flex" mr={3}>
      <Tooltip title={tooltipMsg} placement="bottom-start">
        {icon}
      </Tooltip>

      <Typography variant="caption" gutterBottom className={classes.typographyWithHover}>
        {value}
      </Typography>
    </Box>
  );
};

const labelsForURLs = ["Wiki URL", "GEM wiki page URL ", "GEM Wiki URLs"];

export const DisplayFieldSameLine = (props) => (
  <Box m={0.05} mb="0.05em" display="flex">
    <Typography variant="body2" component="div">
      <Box sx={{ fontWeight: 600 }}>{props.label}: </Box>
    </Typography>

    {labelsForURLs.includes(props.label) ? (
      <Link
        href={props.value}
        target="_blank"
        rel="noopener"
        sx={{ marginLeft: 1, lineHeight: 1, display: "flex", alignItems: "center" }}
      >
        www.gem.wiki
      </Link>
    ) : (
      <Typography
        variant="caption"
        sx={{ marginLeft: 1, lineHeight: 1, display: "flex", alignItems: "center" }}
      >
        {handleNullValue(props.value || "")}
      </Typography>
    )}
  </Box>
);
